export const environment = {
  production: false
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts